import React from 'react';
import { Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { ScrollArea } from './ui/scroll-area';

export const PricingCard = ({ plan, onSelectPlan, isRecommended = false }) => {
  const { name, price, features, description } = plan;

  return (
    <Card 
      className={`relative flex flex-col h-full transition-all duration-300 hover:shadow-xl ${
        isRecommended 
          ? 'border-2 border-[#3E2723] shadow-lg scale-105' 
          : 'border-[#D7CCC8] hover:border-[#8D6E63]'
      }`}
      style={{ backgroundColor: '#EFEBE9' }}
    >
      {isRecommended && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#3E2723] text-white px-4 py-1 rounded-full text-sm font-semibold">
          Recommended
        </div>
      )}
      
      <CardHeader className="text-center pb-4">
        <CardTitle className="text-2xl font-bold text-[#3E2723] mb-2">
          {name}
        </CardTitle>
        <div className="mb-2">
          <span className="text-4xl font-bold text-[#3E2723]">${price}</span>
          <span className="text-[#8D6E63] text-sm ml-2">+ Federal Filing Fee</span>
        </div>
        {description && (
          <CardDescription className="text-[#8D6E63]">{description}</CardDescription>
        )}
      </CardHeader>

      <CardContent className="flex-1 flex flex-col">
        <ScrollArea className="flex-1 pr-4" style={{ maxHeight: '320px' }}>
          <ul className="space-y-3 mb-6">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <Check className="h-5 w-5 text-[#3E2723] flex-shrink-0 mt-0.5" />
                <span className="text-[#3E2723] text-sm">{feature}</span>
              </li>
            ))}
          </ul>
        </ScrollArea>

        <div className="pt-4 mt-auto">
          <p className="text-xs text-[#8D6E63] mb-3 text-center">
            (Govt. filing fee not included)
          </p>
          <Button
            onClick={() => onSelectPlan(plan)}
            className={`w-full font-semibold transition-all duration-300 ${
              isRecommended
                ? 'bg-[#3E2723] hover:bg-[#5D4037] text-white'
                : 'bg-[#8D6E63] hover:bg-[#6D4C41] text-white'
            }`}
          >
            Get Started
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
